/* Package JSON Import will be here */
import React from "react";
import { connect } from "react-redux";
import queryString from 'query-string';
import { bindActionCreators } from "redux";
/* Package JSON Import will be here */

/* Project Import will be here */
import { navigateToDirectLink } from "reducers/common";
/* Project Import will be here */

const PublicRoutesAuthWrapper = (Component) => {
    class PublicRoutesAuthCheck extends React.Component {
        constructor(props) {
            super(props);

            if (this.props.localStore.selectedWholesaler === undefined) {
                localStorage.clear();
                window.location.reload();
            };

            if (this.props.localStore.token && this.props.localStore.selectedWholesaler) {
                this.props.actions.navigateToDirectLink(queryString.parse(this.props.location.search));
                return false;
            }
        }

        render() {
            return (!this.props.localStore.token || !this.props.localStore.selectedWholesaler) ? <Component {...this.props} /> : null;
        }
    }

    const mapStateToProps = state => {
        return {
            localStore: state.localStore
        };
    };

    const mapDispatchToProps = dispatch => {
        return {
            actions: bindActionCreators({
                navigateToDirectLink
            }, dispatch)
        };
    };

    return connect(mapStateToProps, mapDispatchToProps)(PublicRoutesAuthCheck);
};

export default PublicRoutesAuthWrapper;